import { 
  Zap, 
  Shield, 
  Clock, 
  Wallet, 
  Globe, 
  Lock,
  RefreshCw,
  Users,
  Award,
  Headphones
} from 'lucide-react';
import './Features.css';

const Features = () => {
  const features = [
    {
      icon: Zap,
      title: 'Lightning Fast',
      description: 'Complete your exchange in as little as 2 minutes. Our optimized routing ensures the fastest transaction times in the industry.',
      stat: '2 min',
      statLabel: 'Average time',
    },
    {
      icon: Shield,
      title: 'Maximum Security',
      description: 'Non-custodial exchange means we never hold your funds. Your assets remain in your control throughout the entire process.',
      stat: '100%',
      statLabel: 'Non-custodial',
    },
    {
      icon: Clock,
      title: '24/7 Support',
      description: 'Our dedicated support team is available around the clock to assist you with any questions or concerns via live chat.',
      stat: '24/7',
      statLabel: 'Live support',
    },
    {
      icon: Wallet,
      title: 'No Registration',
      description: 'Start exchanging immediately without creating an account. No email, no password, no personal data required.',
      stat: '0',
      statLabel: 'Sign-up needed',
    },
    {
      icon: Globe,
      title: 'Global Coverage',
      description: 'Access to 1000+ cryptocurrencies across 50+ blockchain networks. Trade any asset, anytime, anywhere in the world.',
      stat: '1000+',
      statLabel: 'Cryptocurrencies',
    },
    {
      icon: Lock,
      title: 'Privacy First',
      description: 'We respect your privacy. No KYC required for most transactions. Your financial data stays yours.',
      stat: 'Private',
      statLabel: 'By design',
    },
  ];

  const highlights = [
    { icon: RefreshCw, text: 'Auto-optimized rates' },
    { icon: Award, text: 'Best rate guarantee' },
    { icon: Users, text: '500K+ satisfied users' },
    { icon: Headphones, text: 'Live chat support' },
  ];

  return (
    <section className="features-section" id="features">
      <div className="section-container">
        <div className="section-header">
          <span className="section-label">
            <span className="label-dot" />
            Why Choose Us
          </span>
          <h2 className="section-title">
            The Best Way to{' '}
            <span className="gradient-text">Exchange Crypto</span>
          </h2>
          <p className="section-subtitle">
            Experience a new standard of cryptocurrency exchange with unmatched speed, 
            security, and simplicity.
          </p>
        </div>

        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon-box">
                <feature.icon className="feature-icon" />
              </div>
              
              <div className="feature-content">
                <h3 className="feature-title">{feature.title}</h3>
                <p className="feature-description">{feature.description}</p>
              </div>

              <div className="feature-stat">
                <span className="stat-number">{feature.stat}</span>
                <span className="stat-desc">{feature.statLabel}</span>
              </div>
            </div>
          ))}
        </div>

        <div className="features-highlights">
          {highlights.map((item, index) => (
            <div key={index} className="highlight-item">
              <item.icon className="highlight-icon" />
              <span>{item.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
